import { useCallback } from 'react';
import { useMsalToken } from './use-msal-token';
import axios from 'axios';
import { config } from '../config';

const useApi = () => {
    const apiUrl = config.apiBasePath;
    const { acquireToken } = useMsalToken();

    const http = useCallback(async (
            method: 'GET'|'POST'|'POSTFORM'|'DELETE',
            endpoint: string,
            data?: any,
        ) => {
        const url = `${apiUrl}${endpoint}`;
        const token = await acquireToken();

        const requestConfig = {
            headers: {
                'x-daveme-auth-token': `${token}`
            }
        };

        try {
            switch(method) {
                case 'GET':
                    return await axios.get(url, requestConfig);
                case 'POST':
                    return await axios.post(url, data, requestConfig)
            }      
        } catch (error) {
            console.error('Error making API call:', error);
            throw error;
        }
    }, [apiUrl, acquireToken]);

    return {
        http
    };
};

export default useApi;
